import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import { SupportService } from 'src/app/support.service';
import { ImportMoneyDoc, User } from 'src/typings';
import { ImportMoneyService } from '../import-money.service';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateComponent {
  id: number | undefined;

  doc: ImportMoneyDoc | undefined;

  private subscription: Subscription;

  user: User | undefined;

  dialogRef: MatDialogRef<UpdateComponent> | undefined;

  constructor(
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private importMoneyService: ImportMoneyService,
    private router: Router,
    private userService: UserService,
    private activateRoute: ActivatedRoute,
    public supportService: SupportService,
    private notificationService: NotificationService
  ) {
    this.userService.user.subscribe((user) => {
      this.user = user;
    });
    this.subscription = activateRoute.params.subscribe((params) => {
      this.id = params.id;
      if (this.id) {
        this.importMoneyService.getOne(params.id).subscribe((doc) => {
          this.doc = doc;
          this.loadDoc();
        });
      }
    });
  }

  createForm: UntypedFormGroup = this.fb.group({
    value: new UntypedFormControl(),
    description: new UntypedFormControl(),
    bank: new UntypedFormControl(),
    date: new UntypedFormControl(new Date())
  });

  get date() {
    return this.createForm.controls.date.value;
  }

  get dateFormControl(): UntypedFormControl {
    return this.createForm.controls.date as UntypedFormControl;
  }

  get bank() {
    return this.createForm.controls.bank.value;
  }

  get bankFormControl(): UntypedFormControl {
    return this.createForm.controls.bank as UntypedFormControl;
  }

  get value() {
    return this.createForm.controls.value.value;
  }

  get valueFormControl(): UntypedFormControl {
    return this.createForm.controls.value as UntypedFormControl;
  }

  get description() {
    return this.createForm.controls.description.value;
  }

  get descriptionFormControl(): UntypedFormControl {
    return this.createForm.controls.description as UntypedFormControl;
  }

  loadDoc() {
    if (!this.doc) return this.notificationService.warning('Не могу найти документ!');
    if (this.doc.date) this.dateFormControl.setValue(this.doc.date);
    if (this.doc.description) this.descriptionFormControl.setValue(this.doc.description);
    if (this.doc.bank) this.bankFormControl.setValue(this.doc.bank);
    if (this.doc.value) this.valueFormControl.setValue(this.doc.value);
  }

  save() {
    if (this.doc) {
      this.importMoneyService
        .save({
          id: this.doc.id,
          description: this.description,
          bank_id: this.bank.id,
          value: this.value,
          date: this.date,
          passed: this.doc.passed
        })
        .subscribe(
          () => {
            if (!this.dialogRef) {
              this.router.navigateByUrl('/docs/import_money/list');
            } else {
              this.dialogRef.close();
            }
            this.notificationService.notice(`Документ №${this.id} сохранен!`);
          },
          (err) => {
            this.notificationService.warning(err.error.message);
          }
        );
    } else {
      this.importMoneyService
        .create({
          description: this.description,
          bank_id: this.bank.id,
          value: this.value,
          date: this.date,
          passed: false
        })
        .subscribe(
          (doc) => {
            if (!this.dialogRef) {
              this.router.navigateByUrl('/docs/import_money/list');
            } else {
              this.dialogRef.close();
            }
            this.notificationService.notice(`Документ №${doc.id} сохранен!`);
          },
          (err) => {
            this.notificationService.warning(err.error.message);
          }
        );
    }
  }
}
